/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { 
	useBlockProps,  
	MediaUpload, 
	MediaUploadCheck,
	InspectorControls,
} from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';
import { Button, 
	TextControl, 
	SelectControl,
	__experimentalDivider as Divider,
	__experimentalText as Text,
	PanelBody,
	} from '@wordpress/components';
/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {
	const { src, type, width, height, media } = attributes;

	const onSelectMedia = (newMedia) => {
		setAttributes({src: newMedia.url });
    };

	return (
		<div { ...useBlockProps() }>

			<InspectorControls>
				<PanelBody title={ __( 'Settings' ) }>
					<SelectControl
						label="Video Type"
						value={ type }
						options={ [
							{ label: 'MP4', value: 'video/mp4' },
							{ label: 'WebM', value: 'video/webm' },
							{ label: 'YouTube', value: 'video/youtube' },
						] }
						onChange={(newValue) => setAttributes({ type: newValue, })}
					/>
					<TextControl
						label="Enter Player Width"
						type="number"
						value={width}
						onChange={(newValue) => setAttributes({ width: newValue })}
					/>
					<TextControl
						label="Enter Player height"
						type="number"
						value={height}
						onChange={(newValue) => setAttributes({ height: newValue })}
					/>
				</PanelBody>
			</InspectorControls>
			
			<div className="form-control easy-player-block">
				<Text>
					<h4>
						{ __('Easy Video Player','easy-player') }
					</h4>
				</Text>
				<Divider />
				<br />
				<div className='easy-player-two-block'>
					<TextControl
						label="Enter Video URL"
						type="string"
						value={src}
						onChange={(newValue) => {
							setAttributes({ src: newValue });
						}}
					/>
					<MediaUploadCheck >
						<MediaUpload
							onSelect={onSelectMedia}
							value={media}
							render={({ open }) => (
								<Button className="easy-player-upload" variant="primary" onClick={open}>Upload Video</Button>
							)}
						/>
					</MediaUploadCheck>
				</div>
    
				
			</div>
		</div>
	);
}
